import { patch } from '..';

const updateTicketPriority = (ticketId: string, priority: number) => patch(
  `assets/tickets/${ticketId}`,
  { priority },
);

export default updateTicketPriority;
